import { useCallback, useRef } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";

// Existing socket handlers use React-style setters; keep their identity stable
// while storing each conversation separately in the account query cache.
export default function useChatCache(queryKey) {
  const client = useQueryClient();
  const key = useRef(queryKey);
  key.current = queryKey;
  const query = useQuery({ queryKey, enabled: false, queryFn: async () => null });
  const set = useCallback(value => {
    client.setQueryData(key.current, previous => typeof value === "function" ? value(previous ?? null) : value);
  }, [client]);
  return [query.data ?? null, set];
}
